import { render } from "./divider.vue?vue&type=template&id=2d7f511d&scoped=true"
const script = {}

import "./divider.vue?vue&type=style&index=0&id=2d7f511d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7f511d"]])

export default __exports__